const Field = class Field {
    constructor() {
        this.label = '';
        this.type = 'string';
        this.isRequired = false;
    }
};

export default Field;
